






























































import Vue from 'vue'
import _ from 'lodash'
import AbsencesEditorStartEnd from '@/components/absences/absence/AbsencesEditorStartEnd.vue'
import AbsencesEditorPeriodicity from '@/components/absences/absence/AbsencesEditorPeriodicity.vue'
import AbsencesEditorEmployee from '@/components/absences/absence/AbsencesEditorEmployee.vue'
import AbsencesEditorAdditionalInformation from '@/components/absences/absence/AbsencesEditorAdditionalInformation.vue'
import AbsencesEditorFinish from '@/components/absences/absence/AbsencesEditorFinish.vue'
import { DataPeriodicity, DataStartEnd, PeriodicityPlannedAbsenceEmployee } from '@/types'
import {
  FETCH_AVAILABLE_EMPLOYEES_FOR_PLANNING,
  ABSENCES_ASSISTANT_RESET_STATE,
  ABSENCES_ASSISTANT_INIT_FROM_PAYLOAD,
  ABSENCES_ASSISTANT_SET_FILTERED_EMPLOYEES_BY_DEPARTMENT,
  ABSENCES_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST,
  ABSENCES_ASSISTANT_SET_EMPLOYEE_LIST_FOR_PLANNING,
  ABSENCES_ASSISTANT_SET_ABSENCE_APPROVE,
  CREATE_NEW_ABSENCE,
  ABSENCES_ASSISTANT_SET_ABSENCE_DISAPPROVE,
  EDIT_ABSENCE,
  PLANNING_ASSISTANT_SET_FILTERED_EMPLOYEES_BY_DEPARTMENT,
  FETCH_CAPACITY_LIST,
  ABSENCES_ASSISTANT_SET_PERIODICITY_SERIE,
  ABSENCES_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST,
  ABSENCES_ASSISTANT_SET_IS_EDITING_SERIE,
  EDIT_PERIODICITY_ABSENCE, DELETE_ABSENCE_SERIE
} from '@/store/action-types'
import {
  AbsencePayload,
  AbsenceSeriesDefinition,
  CompanyFilterValue, EmployeeCapacityPayload,
  FetchEmployeeListForPlanningPayload,
  NewAbsencePayload,
  PlanningAssistantPeriodicityPayload, UpdateAbsencePayload, UpdateAbsenceSeriesPayload,
} from '@/types/payload'
import {
  ABSENCES_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING,
  ABSENCES_ASSISTANT_GET_COMPANY_FILTER,
  ABSENCES_ASSISTANT_GET_INITIAL_EMPLOYEE_LIST,
  ABSENCES_ASSISTANT_GET_START_DATE,
  ABSENCES_ASSISTANT_GET_END_DATE,
  ABSENCES_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST,
  ABSENCES_ASSISTANT_GET_ABSENCE_APPROVE,
  ABSENCES_ASSISTANT_GET_ABSENCE_DISAPPROVE,
  ABSENCES_ASSISTANT_GET_ABSENCE_REASON_ITEM,
  ABSENCES_ASSISTANT_GET_PERIODICITY,
  ABSENCES_ASSISTANT_GET_PERIODICITY_SERIE,
  ABSENCES_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST,
  GET_SELECTED_UI_LANGUAGE,
  GET_CURRENT_USER_IS_ABSENCE_APPROVE, GET_CURRENT_USER_ID,
} from '@/store/getter-types'
import { EmployeeAvailableForPlanning } from '@/model/planning/EmployeeAvailableForPlanning'
import { Employee } from '@/model/companyStructure/Employee'
import { ActionsEnum, ViewEnum } from '@/types/enums'
import { EmployeeEvent } from '@/model/planning/EmployeeEvent'
import { Absence } from '@/model/absences/Absence'
import { AbsencesEditorPayload } from '@/model/absences/AbsencesEditorPayload'
import { SelectedEmployee } from '@/model/absences/SelectedEmployee'
import ProgressCircular from '@/components/ProgressCircular.vue'
import moment from 'moment'
import { EmployeeCapacity } from '@/model/planning/EmployeeCapacity'
import { AbsenceSerie, AbwesenheitenInput } from '@/types/service-response'

interface ComponentData {
  dataStartEnd: DataStartEnd | undefined
  dataPeriodicity: DataPeriodicity | undefined
  dataEmployee: Object | undefined
  selectedEmployeeList: SelectedEmployee[]
  isSaveButtonDisabled: boolean
  loading: boolean
  stepper: string
  editAdditionalInformation: boolean
}

export default Vue.extend({
  name: 'AbsencesEditor',

  components: {
    AbsencesEditorStartEnd,
    AbsencesEditorPeriodicity,
    AbsencesEditorEmployee,
    AbsencesEditorAdditionalInformation,
    AbsencesEditorFinish,
    ProgressCircular
  },

  props: {
    showDialog: Boolean,

    absencesEditorPayload: {
      type: Object as () => AbsencesEditorPayload
    },

    action: {
      type: String as () => ActionsEnum
    },

    employeeEventList: {
      type: Array as () => Array<EmployeeEvent>
    },

    editAbsence: Object as () => Absence | undefined,
    editAbsenceSerie: Object as () => AbsenceSerie | undefined,

    isEditingAbsence: Boolean,
    selectedDetailId: Number,

    filteredEmployees: {
      type: Array as () => Array<Employee>
    },
  },

  data (): ComponentData {
    return {
      dataStartEnd: undefined,
      dataPeriodicity: undefined,
      dataEmployee: undefined,
      selectedEmployeeList: [],
      isSaveButtonDisabled: false,
      loading: false,
      stepper: "1",
      editAdditionalInformation: false
    }
  },

  computed: {
    companyFilter (): CompanyFilterValue {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_COMPANY_FILTER]
    },

    initialEmployeeList (): Employee[] {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_INITIAL_EMPLOYEE_LIST]
    },

    dateStart (): Date {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_START_DATE]
    },

    dateEnd (): Date {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_END_DATE]
    },

    selectedLanguage (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },
  },

  methods: {
    onStepperKeyDown (event: any) {
      if(event.code === 'Space' || event.code === 'Enter') {
        if(event.target && event.target.id) {
          this.stepper = event.target.id
        }
      } else if(event.code === 'ArrowDown' && this.stepper === '4') {
        this.editAdditionalInformation = true
      }
    },

    goToNextStep (step: string): void {
      this.stepper = step
      if(step === '4') {
        setTimeout(() => {
          const focusedField: any = document.getElementById('4')
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      }
    },

    async onCloseDialog (): Promise<void> {
      const serie: AbsenceSerie | undefined = this.$store.getters[ABSENCES_ASSISTANT_GET_PERIODICITY_SERIE]
      if(serie && serie.ID && this.action === ActionsEnum.CREATE) {
        await this.$store.dispatch(DELETE_ABSENCE_SERIE, serie.ID)
      }

      this.$store.dispatch(ABSENCES_ASSISTANT_SET_PERIODICITY_SERIE, undefined)
      this.$emit('close')
    },

    onChangeDataStartEnd (data: DataStartEnd): void {
      this.dataStartEnd = data
    },

    onChangeDataPeriodicity (data: DataPeriodicity): void {
      this.dataPeriodicity = data
    },

    onChangeDataEmployeeList (data: object): void {
      this.dataEmployee = data
    },

    async onSaveButtonClick (): Promise<void> {
      this.loading = true
      this.isSaveButtonDisabled = true
      const periodicity: PlanningAssistantPeriodicityPayload = this.$store.getters[ABSENCES_ASSISTANT_GET_PERIODICITY]
      let employeeList: Array<SelectedEmployee> = this.$store.getters[ABSENCES_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
      const dateStart: Date = this.$store.getters[ABSENCES_ASSISTANT_GET_START_DATE]
      const dateEnd: Date = this.$store.getters[ABSENCES_ASSISTANT_GET_END_DATE]
      const absenceReason: number = this.$store.getters[ABSENCES_ASSISTANT_GET_ABSENCE_REASON_ITEM].id
      const absenceApproved: boolean = this.$store.getters[ABSENCES_ASSISTANT_GET_ABSENCE_APPROVE]
      const absenceDisapproved: boolean =  this.$store.getters[ABSENCES_ASSISTANT_GET_ABSENCE_DISAPPROVE]

      if (this.action === ActionsEnum.CREATE && periodicity.isUnique) {
        let newAbsencePayloadList: Array<NewAbsencePayload> = []

        const isAbsenceApproved: boolean =  this.$store.getters[GET_CURRENT_USER_IS_ABSENCE_APPROVE]
        let whoApproved: number | null = null
        if(isAbsenceApproved && absenceApproved) {
          whoApproved = this.currentUserId
        } else if(!isAbsenceApproved && absenceApproved) {
          whoApproved = this.currentUserId
        }

        employeeList.forEach((item: SelectedEmployee) =>
        {
          const newAbsencePayload: NewAbsencePayload = {
            action: 'Insert',
            absenceApproved: absenceApproved,
            absenceDisapproved: absenceDisapproved,
            statusComment: '',
            whoApproved: whoApproved,
            MRAID: '',
            employee: item.id,
            dateStart: dateStart,
            dateEnd: dateEnd,
            comment: item.comment,
            reason: absenceReason,
            who: this.currentUserId,
            showAll: 0,
            medicalCertificate: item.medicalCertificate,
            medicalCertificateValid: item.medicalCertificateValid ? item.medicalCertificateValid : null,
            employeeSecurity: 1,
            component: 'div_Login',
            id: 0
          }
          newAbsencePayloadList.push(newAbsencePayload)
        })

        const payload: AbsencePayload = {
          abteilung: this.companyFilter.department!.id,
          data: newAbsencePayloadList
        }

        try {
          const newAbsence: boolean = await this.$store.dispatch(CREATE_NEW_ABSENCE, payload)

          if (newAbsence) {
            this.$emit('newAbsenceCreated')
          } else {
            this.$emit('newAbsenceCreatedFalse')
          }
        } catch {
          this.$emit('newAbsenceCreatedFalse')
        } finally {
          this.isSaveButtonDisabled = false
          this.loading = false
        }

      } else if (this.action === ActionsEnum.CREATE && !periodicity.isUnique) {
        //Create serie

        /*const details: Array<PeriodicityAbsenceDetails> = []

        employeeList.forEach((item: SelectedEmployee) => {
          details.push(
              {
                employee: item.id,
                comment: item.comment,
                medicalCertificate: item.medicalCertificate,
                medicalCertificateValid: item.medicalCertificateValid ? moment(item.medicalCertificateValid).format('YYYY-MM-DD').toString() : null
              }
          )
        })

        const newPeriodicityAbsencePayload: PeriodicityAbsencePayload = {
          absenceApproved: absenceApproved,
          dateStart: dateStart ? moment(dateStart).format('YYYY-MM-DD HH:mm').toString() : '',
          dateEnd: dateEnd ? moment(dateEnd).format('YYYY-MM-DD HH:mm').toString() : '',
          reason: absenceReason,
          monday: (periodicity.weekDayList.includes(1)) ? 'true' : 'false',
          tuesday: (periodicity.weekDayList.includes(2)) ? 'true' : 'false',
          wednesday: (periodicity.weekDayList.includes(3)) ? 'true' : 'false',
          thursday: (periodicity.weekDayList.includes(4)) ? 'true' : 'false',
          friday: (periodicity.weekDayList.includes(5)) ? 'true' : 'false',
          saturday: (periodicity.weekDayList.includes(6)) ? 'true' : 'false',
          sunday: (periodicity.weekDayList.includes(7)) ? 'true' : 'false',
          whlg: periodicity.repeatEveryNthWeek.toString(),
          unique: periodicity.isUnique ? 'true' : 'false',
          endAfterTimes: periodicity.expireAfterRepetitions.toString(),
          endAfterDate: periodicity.expireAfterDate ? moment(periodicity.expireAfterDate).format('YYYY-MM-DD').toString() : '',
          repetitionRule: "",
          repetitionRuleUI: "",
          details: details
        }

        const newPeriodicityAbsence: boolean = await this.$store.dispatch(CREATE_NEW_PERIODICITY_ABSENCE, newPeriodicityAbsencePayload)

        if (newPeriodicityAbsence) {
          this.$emit('newAbsenceCreated')
        } else {
          this.$emit('newAbsenceCreatedFalse')
        }
        this.isSaveButtonDisabled = false*/
        const periodicityEmployeeList: PeriodicityPlannedAbsenceEmployee[] = this.$store.getters[ABSENCES_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST]
        employeeList = []
        periodicityEmployeeList.forEach((item: PeriodicityPlannedAbsenceEmployee) => {
          item.employeeList.forEach((e: SelectedEmployee) => {
            employeeList.push(e)
          })

        })

        const selectedSerie: AbsenceSerie = this.$store.getters[ABSENCES_ASSISTANT_GET_PERIODICITY_SERIE]
        const series: AbsenceSeriesDefinition = {
          SeriesId: selectedSerie.ID,
          Grund: absenceReason,
          EndAfterDate: periodicity.expireAfterDate ? moment(periodicity.expireAfterDate).format('YYYY-MM-DD') : null,
          Mitarbeiter: selectedSerie.Mitarbeiter,
          StartDatum: selectedSerie.StartDatum,
          EndDatum: selectedSerie.EndDatum,
          StartZeit: selectedSerie.StartZeit,
          EndZeit: selectedSerie.EndZeit,
          Montag: selectedSerie.Montag,
          Dienstag: selectedSerie.Dienstag,
          Mittwoch: selectedSerie.Mittwoch,
          Donnerstag: selectedSerie.Donnerstag,
          Freitag: selectedSerie.Freitag,
          Samstag: selectedSerie.Samstag,
          Sonntag: selectedSerie.Sonntag,
          EndAfternTimes: selectedSerie.EndAfternTimes,
          Einmalig: selectedSerie.Einmalig,
          Whlg: selectedSerie.Whlg,
          Wiederholungsregel: selectedSerie.Wiederholungsregel,
          WiederholungsregelUi: selectedSerie.WiederholungsregelUi,
          Sprache: this.selectedLanguage
        }

        let absences: AbwesenheitenInput[] = []
        let deleted: number[] = []
        selectedSerie.Absences.forEach((item: AbwesenheitenInput) => {
          const foundItem: SelectedEmployee | undefined = employeeList.find((i: SelectedEmployee) => i.detailId === item.ID)
          if(foundItem) {
            item.action = 'Update'
            item.Arztzeugnis = foundItem.medicalCertificate.toString()
            item.Arztzeugnis_GueltigBis = foundItem.medicalCertificateValid ?  moment(foundItem.medicalCertificateValid).format('YYYY-MM-DD HH:mm:ss') : null
            item.Bemerkung = foundItem.comment ? foundItem.comment : null
            absences.push(item)
          } else {
            deleted.push(item.ID)
          }
        })

        employeeList.forEach((item: SelectedEmployee) => {
          if(item.detailId === 0 && selectedSerie.Absences[0]) {
            absences.push(
                {
                  Arztzeugnis: item.medicalCertificate.toString(),
                  Arztzeugnis_GueltigBis: item.medicalCertificateValid ? moment(item.medicalCertificateValid).format('YYYY-MM-DD HH:mm:ss') : null,
                  Bemerkung: item.comment ? item.comment : '',
                  DatumBis: moment(item.end).format('DD.MM.YYYY HH:mm:ss'),
                  DatumVon: moment(item.start).format('DD.MM.YYYY HH:mm:ss'),
                  Grund: selectedSerie.Absences[0].Grund,
                  ID: item.detailId,
                  MRAID: null,
                  Mitarbeiter: item.id ? item.id.toString() : null,
                  RequestApproved: null,
                  RequestDisapproved: null,
                  RequestStatusBemerkungen: null,
                  WhoAproved: null,
                  action: 'Insert',
                  component: null,
                  mitarbeiterSecurity: null,
                  showAll: null,
                  sprache: selectedSerie.Absences[0].sprache,
                  who: null
                }
            )
          }
        })

        const payload: UpdateAbsenceSeriesPayload = {
          Series: series,
          Absences: absences,
          Deleted: deleted,
          Sprache: this.selectedLanguage,
          abteilung: this.companyFilter.department!.id,
          WhoAproved: "1"
        }

        try {
          const response: any = await this.$store.dispatch(EDIT_PERIODICITY_ABSENCE, payload)
          if (!response.IsError) {
            this.$emit('absenceEdited')
          } else {
            this.$emit('absenceEditedFalse')
          }
        } catch {
          this.$emit('absenceEditedFalse')
        } finally {
          this.isSaveButtonDisabled = false
          this.loading = false
        }

      } else if (this.action === ActionsEnum.EDIT && this.isEditingAbsence) {

        /*let whoApproved: number | null = this.editAbsence!.whoApproved
        if(absenceApproved) {
          if(!this.editAbsence!.requestApproved) {
            whoApproved = this.currentUserId
          }
        } else {
          whoApproved = null
        }*/

        const editAbsencePayload: NewAbsencePayload = {
          action: 'Update',
          absenceApproved: absenceApproved,
          absenceDisapproved: absenceDisapproved,
          statusComment: '',
          whoApproved: this.editAbsence!.whoApproved,
          MRAID: this.editAbsence!.MRAID,
          employee: employeeList[0].id,
          dateStart: dateStart,
          dateEnd: dateEnd,
          comment: employeeList[0].comment,
          reason: absenceReason,
          who: this.editAbsence!.who,
          showAll: 0,
          medicalCertificate: employeeList[0].medicalCertificate,
          medicalCertificateValid: employeeList[0].medicalCertificateValid ? employeeList[0].medicalCertificateValid : null,
          employeeSecurity: 1,
          component: 'div_Login',
          id: this.editAbsence!.id
        }

        const payload: UpdateAbsencePayload = {
          abteilung: this.companyFilter.department!.id,
          data: editAbsencePayload
        }

        const editAbsence: any = await this.$store.dispatch(EDIT_ABSENCE, payload)

        if (editAbsence) {
          this.$emit('absenceEdited')
        } else {
          this.$emit('absenceEditedFalse')
        }
        this.isSaveButtonDisabled = false
        this.loading = false
      } else if (this.action === ActionsEnum.EDIT && !this.isEditingAbsence) {
        //Edit serie

        const periodicityEmployeeList: PeriodicityPlannedAbsenceEmployee[] = this.$store.getters[ABSENCES_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST]
        employeeList = []
        periodicityEmployeeList.forEach((item: PeriodicityPlannedAbsenceEmployee) => {
          item.employeeList.forEach((e: SelectedEmployee) => {
            employeeList.push(e)
          })

        })

        const selectedSerie: AbsenceSerie = this.$store.getters[ABSENCES_ASSISTANT_GET_PERIODICITY_SERIE]
        const series: AbsenceSeriesDefinition = {
          SeriesId: selectedSerie.ID,
          Grund: absenceReason,
          EndAfterDate: periodicity.expireAfterDate ? moment(periodicity.expireAfterDate).format('YYYY-MM-DD') : null,
          Mitarbeiter: selectedSerie.Mitarbeiter,
          StartDatum: selectedSerie.StartDatum,
          EndDatum: selectedSerie.EndDatum,
          StartZeit: selectedSerie.StartZeit,
          EndZeit: selectedSerie.EndZeit,
          Montag: selectedSerie.Montag,
          Dienstag: selectedSerie.Dienstag,
          Mittwoch: selectedSerie.Mittwoch,
          Donnerstag: selectedSerie.Donnerstag,
          Freitag: selectedSerie.Freitag,
          Samstag: selectedSerie.Samstag,
          Sonntag: selectedSerie.Sonntag,
          EndAfternTimes: selectedSerie.EndAfternTimes,
          Einmalig: selectedSerie.Einmalig,
          Whlg: selectedSerie.Whlg,
          Wiederholungsregel: selectedSerie.Wiederholungsregel,
          WiederholungsregelUi: selectedSerie.WiederholungsregelUi,
          Sprache: this.selectedLanguage
        }

        let absences: AbwesenheitenInput[] = []
        let deleted: number[] = []
        selectedSerie.Absences.forEach((item: AbwesenheitenInput) => {
          const foundItem: SelectedEmployee | undefined = employeeList.find((i: SelectedEmployee) => i.detailId === item.ID)
          if(foundItem) {
            item.action = 'Update'
            item.Arztzeugnis = foundItem.medicalCertificate.toString()
            item.Arztzeugnis_GueltigBis = foundItem.medicalCertificateValid ?  moment(foundItem.medicalCertificateValid).format('YYYY-MM-DD HH:mm:ss') : null
            item.Bemerkung = foundItem.comment ? foundItem.comment : ''
            absences.push(item)
          } else {
            deleted.push(item.ID)
          }
        })

        employeeList.forEach((item: SelectedEmployee) => {
          if(item.detailId === 0 && selectedSerie.Absences[0]) {
            absences.push(
                {
                  Arztzeugnis: item.medicalCertificate.toString(),
                  Arztzeugnis_GueltigBis: item.medicalCertificateValid ? moment(item.medicalCertificateValid).format('YYYY-MM-DD HH:mm:ss') : null,
                  Bemerkung: item.comment ? item.comment : '',
                  DatumBis: moment(item.end).format('YYYY-MM-DD HH:mm:ss'),
                  DatumVon: moment(item.start).format('YYYY-MM-DD HH:mm:ss'),
                  Grund: selectedSerie.Absences[0].Grund,
                  ID: item.detailId,
                  MRAID: null,
                  Mitarbeiter: item.id ? item.id.toString() : null,
                  RequestApproved: null,
                  RequestDisapproved: null,
                  RequestStatusBemerkungen: null,
                  WhoAproved: null,
                  action: 'Insert',
                  component: null,
                  mitarbeiterSecurity: null,
                  showAll: null,
                  sprache: selectedSerie.Absences[0].sprache,
                  who: null
                }
            )
          }
        })

        const payload: UpdateAbsenceSeriesPayload = {
          Series: series,
          Absences: absences,
          Deleted: deleted,
          Sprache: this.selectedLanguage,
          abteilung: this.companyFilter.department!.id,
          WhoAproved: "1"
        }

        try {
          const response: any = await this.$store.dispatch(EDIT_PERIODICITY_ABSENCE, payload)
          if (!response.IsError) {
            this.$emit('absenceEdited')
          } else {
            this.$emit('absenceEditedFalse')
          }
        } catch {
          this.$emit('absenceEditedFalse')
        } finally {
          this.isSaveButtonDisabled = false
          this.loading = false
        }
      }
    },

    async onEmployeeStepClick (): Promise<void> {
      const availableEmployeeList: EmployeeAvailableForPlanning[] = this.$store.getters[ABSENCES_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING]
      const employeeIdList: Array<number> = availableEmployeeList.map((i: EmployeeAvailableForPlanning) => {
        return i.id
      })
      const employeeCapacityList: Array<EmployeeCapacity> = await this.fetchCapacityList(employeeIdList)

      const employeeForPlanningList: EmployeeAvailableForPlanning[] = availableEmployeeList.map((item: EmployeeAvailableForPlanning) => {
        const foundEmployee: EmployeeCapacity | undefined = employeeCapacityList.find((employee: EmployeeCapacity) => employee.id === item.id)
        const employee: EmployeeAvailableForPlanning = item.updateCapacity (foundEmployee ? foundEmployee.capacity : item.capacity)
        return employee
      })

      this.$store.dispatch(ABSENCES_ASSISTANT_SET_EMPLOYEE_LIST_FOR_PLANNING, employeeForPlanningList)
    },

    async fetchCapacityList (employeeIdList: Array<number>): Promise<Array<EmployeeCapacity>> {

      const payload: EmployeeCapacityPayload = {
        employeeIdList: employeeIdList,
        calendarDate: moment(this.$store.getters[ABSENCES_ASSISTANT_GET_START_DATE]).format('DD/MM/YYYY'),
        view: ViewEnum.Month
      }

      return await this.$store.dispatch(FETCH_CAPACITY_LIST, payload)
    },
  },

  beforeMount (): void {
    const payload: AbsencesEditorPayload = this.absencesEditorPayload

    this.$store.dispatch(ABSENCES_ASSISTANT_RESET_STATE)
    this.$store.dispatch(ABSENCES_ASSISTANT_INIT_FROM_PAYLOAD, payload)
  },

  async mounted (): Promise<void> {
    if (this.companyFilter.department) {
      const payload: FetchEmployeeListForPlanningPayload = {
        departmentId: this.companyFilter.department.id
      }

      const filteredEmployeesByDepartment: Array<Employee> = this.filteredEmployees.filter((item: Employee) => item.department === this.companyFilter.department!.id)
      this.$store.dispatch(ABSENCES_ASSISTANT_SET_FILTERED_EMPLOYEES_BY_DEPARTMENT, filteredEmployeesByDepartment)
      this.$store.dispatch(PLANNING_ASSISTANT_SET_FILTERED_EMPLOYEES_BY_DEPARTMENT, filteredEmployeesByDepartment)

      const availableEmployeeForPlanning: EmployeeAvailableForPlanning[] = await this.$store.dispatch(FETCH_AVAILABLE_EMPLOYEES_FOR_PLANNING, payload)
      const employeeForPlanningList = _.intersectionBy(availableEmployeeForPlanning, this.filteredEmployees, 'id')
      this.$store.dispatch(ABSENCES_ASSISTANT_SET_EMPLOYEE_LIST_FOR_PLANNING, employeeForPlanningList)

      if (this.initialEmployeeList.length) {
        const plannedEmployeeList: SelectedEmployee[] = this.initialEmployeeList
          .filter((initialEmployeeItem: Employee) => {
            return _.find(employeeForPlanningList, { id: initialEmployeeItem.id })
          })
          .map((initialEmployeeItem: Employee) => {
            const plannableEmployeeItem: EmployeeAvailableForPlanning = _.find(employeeForPlanningList, { id: initialEmployeeItem.id }) as EmployeeAvailableForPlanning

            return new SelectedEmployee(
              plannableEmployeeItem.id,
              plannableEmployeeItem.name,
              plannableEmployeeItem.capacity,
              plannableEmployeeItem.isFloater,
              plannableEmployeeItem.planingGroupName,
              false,
              undefined,
              '',
              this.dateStart,
              this.dateEnd,
                undefined
            )
          })

        this.$store.dispatch(ABSENCES_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, plannedEmployeeList)
      }
    }
    if (this.action === ActionsEnum.EDIT && this.isEditingAbsence) {
      if (this.editAbsence) {
        const availableEmployeeList: EmployeeAvailableForPlanning[] = this.$store.getters[ABSENCES_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING]
        const plannedEmployeeList: SelectedEmployee[] = this.$store.getters[ABSENCES_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
        const employeeList: EmployeeAvailableForPlanning[] =  availableEmployeeList.filter((item: EmployeeAvailableForPlanning) => {
          return !_.find(plannedEmployeeList, {id: item.id})
        })

        const availableEmployee: EmployeeAvailableForPlanning | undefined = employeeList.find((item: EmployeeAvailableForPlanning) => item.id === this.editAbsence!.employeeId)

        if (availableEmployee) {
          this.selectedEmployeeList.push(new SelectedEmployee(
            availableEmployee.id,
            availableEmployee.name,
            availableEmployee.capacity,
            availableEmployee.isFloater,
            availableEmployee.planingGroupName,
            this.editAbsence.medicalCertificate,
            this.editAbsence.medicalCertificateValid,
            this.editAbsence.comment,
            this.dateStart,
            this.dateEnd,
            undefined
          ))
        }
        this.$store.dispatch(ABSENCES_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, this.selectedEmployeeList)
        this.$store.dispatch(ABSENCES_ASSISTANT_SET_ABSENCE_APPROVE, this.editAbsence.requestApproved)
        this.$store.dispatch(ABSENCES_ASSISTANT_SET_ABSENCE_DISAPPROVE, this.editAbsence.requestDisapproved)
      }
    } else if(this.action === ActionsEnum.EDIT && this.editAbsenceSerie) {
      // Edit serie

      const availableEmployeeList: EmployeeAvailableForPlanning[] = this.$store.getters[ABSENCES_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING]
      const plannedEmployeeList: SelectedEmployee[] = this.$store.getters[ABSENCES_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
      const employeeList: EmployeeAvailableForPlanning[] =  availableEmployeeList.filter((item: EmployeeAvailableForPlanning) => {
        return !_.find(plannedEmployeeList, {id: item.id})
      })

      this.editAbsenceSerie.Absences.forEach((item: AbwesenheitenInput, index: number) => {
        const foundEmployee: EmployeeAvailableForPlanning | undefined = employeeList.find((employee: EmployeeAvailableForPlanning) => employee.id ? employee.id.toString() === item.Mitarbeiter : false)
        if(foundEmployee) {
          this.selectedEmployeeList.push(
              new SelectedEmployee(
                  foundEmployee.id,
                  foundEmployee.name,
                  foundEmployee.capacity,
                  foundEmployee.isFloater,
                  foundEmployee.planingGroupName,
                  item.Arztzeugnis && (item.Arztzeugnis === 'true' || item.Arztzeugnis === 'True') ? true : false,
                  item.Arztzeugnis_GueltigBis ? moment(item.Arztzeugnis_GueltigBis, 'DD.MM.YYYY HH:mm:ss').toDate() : undefined,
                  item.Bemerkung ? item.Bemerkung : '',
                  moment(item.DatumVon, 'DD.MM.YYYY').toDate(),
                  moment(item.DatumBis, 'DD.MM.YYYY').toDate(),
                  index,
                  item.ID
              )
          )
        }
      })

      let data: PeriodicityPlannedAbsenceEmployee[] = []
      this.selectedEmployeeList.forEach((item: SelectedEmployee) => {
        let foundItem: PeriodicityPlannedAbsenceEmployee | undefined

        if (data.length > 0) {
          foundItem = data.find((i: PeriodicityPlannedAbsenceEmployee) => i.date === moment(item.start).format('DD.MM.YYYY'))
        }

        if (foundItem) {
          foundItem.employeeList.push(item)
        } else {
          data.push({ date: moment(item.start).format('DD.MM.YYYY'), seriesId: this.editAbsenceSerie && this.editAbsenceSerie.ID ? this.editAbsenceSerie.ID : null, employeeList: [item] })
        }
      })

      data = _.sortBy(data, [function(o) { return moment(o.date, 'DD.MM.YYYY').format('YYYY-MM-DD'); }])

      this.$store.dispatch(ABSENCES_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, data)
      this.$store.dispatch(ABSENCES_ASSISTANT_SET_IS_EDITING_SERIE, true)
      this.$store.dispatch(ABSENCES_ASSISTANT_SET_PERIODICITY_SERIE, this.editAbsenceSerie)
      //this.$store.dispatch(ABSENCES_ASSISTANT_SET_ABSENCE_APPROVE, this.editAbsenceSerie.requestApproved)
      //this.$store.dispatch(ABSENCES_ASSISTANT_SET_ABSENCE_DISAPPROVE, this.editAbsenceSerie.requestDisapproved)
    }
  }
})
